<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LIcon,  } from "@vue-leaflet/vue-leaflet";

export default {
  data() {
    return {
      markersList: [],
      zoom: 4,
      center: latLng(-11.41322, -60.219482),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withTooltip: latLng(47.41422, -1.250482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
    };
  },
  props: {
    pessoasList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,

  },
  methods: {
    innerClick() {
      alert("Click!");
    },
  },
  mounted() {
    console.log('mounted basic_map')
    console.log(this.pessoasList)

    this.pessoasList.forEach((value) => {
      if (value.latlong){
        console.log('latlong')
        console.log(value.latlong)

        const latLong = value.latlong
        const posVirg = latLong.indexOf(",");
        const lat =  parseFloat(latLong.substring(0, posVirg))
        const long = parseFloat(latLong.substring(posVirg + 2, latLong.length))

        const latlong = latLng(lat, long)

        this.markersList.push({
          'id': value.id,
          'codigo': value.codigo,
          'nome': value.nome,
          'cnpj': value.cnpj,
          'cidade': value.cidade,
          'estado': value.estado,
          'latlong': latlong
        })
      }
    })
    console.log('this.markersList')
    console.log(this.markersList)
  }
};
</script>

<template>
  <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 400px; width: 100%"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <l-marker
        v-for="marker in markersList" :key="marker.id"
        :lat-lng="marker.latlong">
            <l-icon>
              <img src="@/assets/images/leaflet/mark_red.png" />
            </l-icon>
      <l-popup>
        <div>
          {{ marker.nome }}
          <div>
          <span class="text-black-50">
            {{marker.cnpj}}
          </span>
          </div>
          <router-link :to="`/cliente/detalhe/${marker.id}`" target="_blank" class="text-dark">
            Código: {{ marker.codigo }}
          </router-link>

          <p>
          <span class="text-black">
            {{ marker.cidade }}, {{ marker.estado }}
          </span>
          </p>
        </div>
      </l-popup>
    </l-marker>
  </l-map>
</template>